<template>
  <div id="app" style="width:90%">
    <el-button type="primary" size="small" style="margin:1%" round @click="editialogVisible()">新增菜单</el-button>
    <el-table :data="menusData" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
      element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" row-key="id"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column prop="id" label="父级编号" sortable align="center" :formatter="changeNull">
      </el-table-column>
      <el-table-column prop="fname" label="菜单名" align="center" :formatter="changeNull">
      </el-table-column>
      <el-table-column prop="routePath" label="路由路径" align="center" :formatter="changeNull">
      </el-table-column>
      <el-table-column prop="icon" label="图标" align="center" :formatter="changeNull">
      </el-table-column>
      <el-table-column prop="orders" label="排序编号" align="center" :formatter="changeNull">
      </el-table-column>
      <el-table-column prop="createDate" label="创建时间" align="center" :formatter="changeNull">
      </el-table-column>
      <el-table-column  label="操作"  fixed="right" align="center">
        　　　　<template slot-scope="scope">
          <el-button size="small" type="text" @click="editialogVisible(scope.row.id)">编辑</el-button>
          　　　　　　<el-button size="small" type="text" @click="toDeleteRole(scope.row.id)">删除</el-button>
          　　　　
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-pagination style="margin: 20px 0px 20px;" background :current-page="menusData.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="menusData.total"
			@size-change="handleSizeChange">
		</el-pagination> -->

    <!-- 编辑 -->
    <el-dialog style="float:rigin" :title="poupTitle" :visible.sync="dialogVisible" width="35%" :close-on-click-modal="false">
      <div class="app-container">
        <el-form ref="form" :rules="mainFormRules" :label-width="formLabelWidth" size="medium">
          <el-form-item label="父级菜单:" v-if="form.pid!=0">
            <el-col :span="8">
              <el-select v-model="form.pid" class="big" placeholder="请选择" clear>
                <el-option :value="0" label="无">无</el-option>
                <el-option v-for="item in allMenus.list" :key="item.id" :value="item.id" :label="item.fname">
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>

          <el-form-item :label-width="formLabelWidth" label="菜单名称:">
            <el-col :span="8">
              <el-input v-model="form.fname" placeholder="请输入菜单名称" />
            </el-col>
          </el-form-item>

          <el-form-item v-if="form.pid!='0'" :label-width="formLabelWidth" label="路由地址:">
            <el-col :span="10">
              <el-input v-model="form.routePath" placeholder="请输入路由地址" />
            </el-col>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth" label="图标(选填):">
            <el-col :span="10">
              <el-input v-model="form.icon" placeholder="请输入图标" />
            </el-col>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth" label="排序编号:">
            <el-col :span="10">
              <el-input v-model="form.orders" placeholder="请输入排序编号" />
            </el-col>
          </el-form-item>

          <el-form-item>
            <el-button :loading="loading" type="primary" @click="edit()">提交</el-button>
            <el-button @click="dialogVisible = false">取 消</el-button>
            <!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loading: false,
        menusData: [{}], //菜单列表
        dialogVisible: false, //编辑弹框
        ids: '',//授权用户id
        formLabelWidth: "200px",
        form: {
          fname: "",
          routePath: "",
          pid: "0",
          icon: "",
          orders: ""
        },
        mainFormRules: {
          fname: { required: true, message: "请输入菜单名称", trigger: "blur" },
          orders: { required: true, message: "请输入排序编号", trigger: "blur" },

        },
        allMenus: [],
        poupTitle: '',
        page: {
					pageNum: 1,
					pageSize: 10
				},
      };
    },
    methods: {
      pageChange(data) {
				this.page.pageNum = data
				this.getStoreGoodsList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getStoreGoodsList()
			},
      //编辑弹框
      editialogVisible(id) {
        if (id) {
          //编辑
          this.ids = id
          this.findMenueByUserId(id);
          this.poupTitle = '编辑'
        } else {
          this.ids = ""
          this.form = {}
          this.poupTitle = '新增'
        }
        var data = {
          pid: 0
        }
        this.$api.getAllMenus(data).then((res) => {
          if (res.state == 'success') {
            this.allMenus = res.data
          }
        })
        this.dialogVisible = true;
      },
      edit() { //新增角色权限列表
        if (this.ids) {
          //编辑
          let data = {
            id: this.ids,
            fname: this.form.fname,
            routePath: this.form.routePath,
            pid: this.form.pid,
            icon: this.form.icon,
            orders: this.form.orders

          }
          this.$api.editMenus(data).then((res) => {
            if (res.state == 'success') {
              this.$message({
                message: res.message,
                type: 'success'
              });
              this.dialogVisible = false;
              this.queryList();
            } else {
              this.$message.error(res.message);
            }
          })
        } else {
          //添加
          let data = {
            fname: this.form.fname,
            routePath: this.form.routePath,
            pid: this.form.pid,
            icon: this.form.icon,
            orders: this.form.orders
          }
          this.$api.insertMenus(data).then((res) => {
            if (res.state == 'success') {
              this.$message({
                message: res.message,
                type: 'success'
              });
              this.dialogVisible = false;
              this.queryList();
            } else {
              this.$message.error(res.message);
            }
          })
        }
      },
      //根据id查询角色
      findMenueByUserId(id) {
        this.$api.findMenueByUserId(id).then((res) => {
          if (res.state == 'success') {
            this.form = res.data
          }
        })
      },
      //菜单列表
      queryList() {
        this.loading = true
        let data={
          pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
        }
        this.$api.getMenusList().then((res) => {
          if (res.state == 'success') {
            // console.log('表格数据---', res.data)
            this.menusData = res.data
          }
          this.loading = false
        })
      },
      //删除角色
      toDeleteRole(id) {
        this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.deleteMenus(id).then((res) => {
            if (res.state == 'success') {
              this.$message({
                message: res.message,
                type: 'success'
              });
              this.queryList();
            } else {
              this.$message.error(res.message);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      },
      headClass() {
        return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
      },
      changeNull(row, column, cellValue) {
        if (cellValue) {
          return cellValue;
        } else {
          return "暂无";
        }
      }
    },
    created() {
      this.queryList();
    }
  };
</script>

<style>
</style>